import { gql } from '@apollo/client';

const CREATE_ACCESS_LINK_EVENT = gql`
  mutation createAccessLinkEvent($data: AccessLinkEventCreateInput!) {
    createAccessLinkEvent(data: $data)
  }
`;

export default CREATE_ACCESS_LINK_EVENT;
